import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class NetworkTimeoutError extends EluveError {
  static override readonly errorName = 'NetworkTimeoutError';
  readonly logLevel: LogLevel = 'error';

  constructor(message = 'Network operation timed out', args?: EluveErrorArgs) {
    super(message, args);
  }
}
